import { makeStyles } from "@material-ui/core/styles";

const useTriggerTypesStyles = makeStyles((theme) => ({
  page: {
    width: "100%",
    fontFamily: "'DM Sans', sans-serif",
  },
  card: {
    overflow: "hidden",
    border: "1px solid #cdd8e8",
    borderRadius: 14,
    height: "80vh",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 16px rgba(15, 26, 46, 0.06)",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(2.5),
    borderBottom: "1px solid #dbe3ef",
    [theme.breakpoints.down("xs")]: {
      alignItems: "stretch",
      flexDirection: "column",
    },
  },
  headingGroup: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    gap: theme.spacing(1.5),
  },
  headingIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 38,
    height: 38,
    flexShrink: 0,
    borderRadius: 10,
    backgroundColor: "#eef8fa",
    color: "#008e9d",
  },
  heading: {
    margin: 0,
    color: "#0f1a2e",
    fontSize: 15,
    fontWeight: 700,
    lineHeight: 1.35,
  },
  subtitle: {
    margin: "3px 0 0",
    color: "#6b7a99",
    fontSize: 11.5,
    lineHeight: 1.4,
  },
  createButton: {
    minHeight: 38,
    borderRadius: 9,
    backgroundColor: "#00a3b4",
    color: "#ffffff",
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: 700,
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#008e9d",
      boxShadow: "0 5px 14px rgba(0, 163, 180, 0.22)",
    },
  },
  filterBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(2, 2.5),
    backgroundColor: "#f8fafc",
    [theme.breakpoints.down("xs")]: {
      alignItems: "stretch",
      flexDirection: "column",
    },
  },
  searchField: {
    width: "min(440px, 100%)",
    "& .MuiOutlinedInput-root": {
      borderRadius: 9,
      backgroundColor: "#ffffff",
      fontSize: 13,
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00a3b4",
      },
    },
  },
  resultCount: {
    color: "#6b7a99",
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    whiteSpace: "nowrap",
  },
  tableWrap: {
    width: "100%",
    overflowX: "auto",
    height: "calc(80vh - 220px)",
  },
  table: {
    minWidth: 680,
  },
  tableHead: {
    backgroundColor: "#1f456b",
  },
  headCell: {
    padding: "11px 16px",
    borderBottom: 0,
    color: "#ffffff",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.5,
  },
  bodyCell: {
    padding: "10px 16px",
    borderBottom: "1px solid #e0e7f1",
    color: "#24334a",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 12.5,
  },
  codeBadge: {
    display: "inline-flex",
    alignItems: "center",
    minWidth: 64,
    minHeight: 28,
    padding: "4px 10px",
    border: "1px solid #cbd8e8",
    borderRadius: 7,
    backgroundColor: "#fbfdff",
    color: "#173a5e",
    fontFamily: "'DM Mono', monospace",
    fontSize: 11.5,
    fontWeight: 500,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  editButton: {
    padding: 7,
    borderRadius: 8,
    backgroundColor: "#e8f5f7",
    color: "#008e9d",
    "&:hover": {
      backgroundColor: "#d7eef1",
    },
  },
  deleteButton: {
    padding: 7,
    borderRadius: 8,
    backgroundColor: "#feeceb",
    color: "#d92d28",
    "&:hover": {
      backgroundColor: "#fddbd8",
    },
  },
  stateCell: {
    padding: theme.spacing(6, 2),
    borderBottom: 0,
    color: "#718096",
    textAlign: "center",
  },
  loading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
  },
  pagination: {
    borderTop: "1px solid #dbe3ef",
    backgroundColor: "#fbfdff",
    color: "#52627d",
    "& .MuiTablePagination-toolbar": {
      minHeight: 54,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },
    "& .MuiTablePagination-caption, & .MuiTablePagination-selectRoot": {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: 12,
    },
  },
  dialogPaper: {
    width: "100%",
    maxWidth: 520,
    borderRadius: 14,
  },
  dialogTitle: {
    paddingBottom: theme.spacing(1),
    color: "#0f1a2e",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: 18,
    fontWeight: 700,
  },
  dialogSubtitle: {
    margin: "0 0 18px",
    color: "#6b7a99",
    fontSize: 12,
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "130px minmax(0, 1fr)",
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
    },
  },
  formField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 9,
      fontSize: 13,
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00a3b4",
      },
    },
  },
  dialogActions: {
    padding: theme.spacing(1.5, 3, 2.5),
  },
  cancelButton: {
    borderRadius: 8,
    color: "#52627d",
    fontWeight: 600,
    textTransform: "none",
  },
  saveButton: {
    minWidth: 110,
    borderRadius: 8,
    backgroundColor: "#00a3b4",
    color: "#ffffff",
    fontWeight: 700,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#008e9d",
    },
  },
  confirmDeleteButton: {
    borderRadius: 8,
    backgroundColor: "#d92d28",
    color: "#ffffff",
    fontWeight: 700,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#b42318",
    },
  },
}));

export default useTriggerTypesStyles;
